var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-dropdown-menu',{staticClass:"van-select",attrs:{"direction":"up"}},[_c('van-dropdown-item',{attrs:{"title":_vm.valueName,"options":_vm.options},on:{"change":_vm.onChange},model:{value:(_vm.index),callback:function ($$v) {_vm.index=$$v},expression:"index"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5866dfbc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CmSelect/index.vue
// module id = null
// module chunks = 